import { Link } from 'react-router-dom';

const servicesList = [
  {
    id: 'eye-care',
    image: '/images/eyecare_service.png',
    title: 'Eye Care',
    desc: 'Our ophthalmology department delivers the full spectrum of eye health services — from routine refractive checks to complex surgical procedures. Our experienced eye surgeons use the latest diagnostic imaging and laser technology to preserve and restore your vision.',
    subServices: [
      'Cataract Surgery (Phacoemulsification)',
      'LASIK & PRK Laser Vision Correction',
      'Glaucoma Screening & Treatment',
      'Retina & Vitreous Disorders',
      'Pediatric Ophthalmology & Squint Correction',
      'Dry Eye Clinic & Management',
      'Diabetic Retinopathy Monitoring'
    ],
    btnText: 'Book Eye Appointment'
  },
  {
    id: 'maternity',
    image: '/images/maternity_service.png',
    title: 'Maternity Care',
    desc: 'We walk with mothers through every stage of their pregnancy journey — from the very first scan to post-delivery recovery. Our caring gynecologists and nurses ensure that both mother and baby receive attentive, expert care in a safe and welcoming environment.',
    subServices: [
      'Prenatal Care & Antenatal Check-Ups',
      'High-Risk Pregnancy Management',
      'Normal & Cesarean Delivery',
      'Postpartum Care & Lactation Support',
      'Obstetric Ultrasound & Doppler scans',
      'Gynecological Consultations',
      'Family Planning Counseling'
    ],
    btnText: 'Book Maternity Visit'
  },
  {
    id: 'pediatrician',
    image: '/images/pediatric_service.png',
    title: 'Pediatrician',
    desc: 'Our child-friendly pediatric department provides compassionate healthcare for newborns, toddlers, children, and adolescents. We monitor growth and development, treat illnesses, and guide parents at every milestone with clear, reassuring advice.',
    subServices: [
      'Newborn & Neonatal Care',
      'Childhood Vaccinations & Immunization Schedule',
      'Growth Monitoring & Nutritional Counseling',
      'Fever, Infections & Respiratory Conditions',
      'Developmental Milestone Assessment',
      'Child Allergy & Asthma Management',
      'Adolescent Health Evaluations'
    ],
    btnText: 'Book Pediatric Visit'
  },
  {
    id: 'cosmetic-gynae',
    image: '/images/cosmetic_gynae_service.png',
    title: 'Cosmetic Gynecology',
    desc: 'Our cosmetic gynecology service is conducted with the highest levels of discretion, confidentiality, and clinical expertise. Our female specialists create a safe, non-judgmental space for women seeking functional or aesthetic gynecological procedures.',
    subServices: [
      'Laser Vaginal Rejuvenation',
      'Labiaplasty & Vaginoplasty',
      'Hymenoplasty (Hymen Repair)',
      'Clitoral Hood Reduction',
      'Non-Surgical Tightening Treatments',
      'Urinary Incontinence Management',
      'Intimate Aesthetics Consultations'
    ],
    btnText: 'Confidential Consultation'
  },
  {
    id: 'ent',
    image: '/images/ent_service.png',
    title: 'ENT (Ear, Nose & Throat)',
    desc: 'Our ENT department addresses a wide range of conditions affecting the head and neck, from chronic sinusitis and hearing loss to throat disorders and sleep breathing problems. We offer both medical and surgical solutions tailored to each patient.',
    subServices: [
      'Hearing Assessment & Audiometry',
      'Tonsillectomy & Adenoidectomy',
      'Sinus Surgery (FESS)',
      'Nasal Septum Correction (Septoplasty)',
      'Thyroid & Salivary Gland Disorders',
      'Sleep Apnea & Snoring Treatment',
      'Voice & Swallowing Disorders'
    ],
    btnText: 'Book ENT Appointment'
  },
  {
    id: 'dental',
    image: '/images/dental_service.png',
    title: 'Dental Clinic',
    desc: 'Our modern dental clinic offers complete oral healthcare for the whole family — from preventive hygiene and fillings to cosmetic dentistry, orthodontics, and dental implants. Our gentle approach ensures every patient feels comfortable and confident.',
    subServices: [
      'Routine Cleaning & Scaling',
      'Teeth Whitening & Bleaching',
      'Dental Implants & Crowns',
      'Orthodontics: Metal & Clear Aligners',
      'Root Canal Treatment',
      'Pediatric Dentistry',
      'Veneers & Smile Makeovers'
    ],
    btnText: 'Book Dental Visit'
  }
];

function Services() {
  return (
    <>
      {/* Page Hero */}
      <section className="page-hero" style={{ backgroundImage: 'linear-gradient(rgba(8, 50, 62, 0.85), rgba(8, 50, 62, 0.85)), url(/images/hero_services.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="container">
          <div className="eyebrow" style={{ color: 'var(--gold-light)' }}>What We Offer</div>
          <h1>Our Medical Services</h1>
          <p>Six specialized clinical departments, one commitment — exceptional care for you and your family.</p>
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="sep">›</span>
            <span className="current">Services</span>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section-pad">
        <div className="container">
          <div className="services-full-grid">
            {servicesList.map(service => (
              <div key={service.id} className="service-full-card" id={service.id}>
                <div className="service-full-img" style={{ overflow: 'hidden', borderRadius: 'var(--radius-lg)' }}>
                  <img src={service.image} alt={service.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div className="service-full-body">
                  <h3>{service.title}</h3>
                  <p>{service.desc}</p>
                  
                  <div className="benefits-list">
                    <h5>Treatments & Services Include</h5>
                    <ul>
                      {service.subServices.map(sub => (
                        <li key={sub}>{sub}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div>
                    <Link to="/contact" className="btn btn-primary btn-sm">{service.btnText}</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Diagnostics Referral Card */}
          <div className="card" style={{ marginTop: 60, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 24, background: 'var(--teal-soft)', borderColor: 'var(--border)' }}>
            <div style={{ maxWidth: 650 }}>
              <div className="eyebrow">Need Lab Tests or Scans?</div>
              <h3 style={{ fontSize: '1.5rem', marginBottom: 10 }}>In-House Diagnostics Wing Available</h3>
              <p style={{ fontSize: '0.92rem', marginBottom: 0 }}>
                We also host an ISO-certified diagnostic laboratory and advanced ultrasound imaging center. Same-day reports, home sample collection, and private ultrasound rooms.
              </p>
            </div>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
              <Link to="/blood-test" className="btn btn-secondary">Blood Test & Imaging</Link>
              <Link to="/contact" className="btn btn-primary">Book a Scan Now</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Services;
